<template>
  <div class="tab-container ">
    <div class="padd80 bg-white">
      <Title activeColor='#293333'
             activeText='公司主要证书及社会信誉'></Title>
      <div class="zhengshu-list margT80">
        <img src="../../assets/images/about-us/zhengshu/zheshu3.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu4.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu5.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu6.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu7.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu8.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu9.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu10.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu11.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu12.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu15.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu16.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu13.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu14.png"
             alt="">
      </div>
      <!-- <div class="img-bottom-list">
        <div class="img-bu img-margin-style">
          <img src="../../assets/images/about-us/zhengshu/zheshu15.png"
               alt="">
          <img style="margin-top: 0.4rem;"
               src="../../assets/images/about-us/zhengshu/zheshu16.png"
               alt="">
        </div>
        <img class="img-margin-style"
             src="../../assets/images/about-us/zhengshu/zheshu13.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu14.png"
             alt="">
        <img src="../../assets/images/about-us/zhengshu/zheshu12.png"
             alt="">
      </div> -->
    </div>
  </div>
</template>
<script>
import Title from '../../components/title';
export default {
  components: {
    Title
  },
  data () {
    return {

    }
  }
}
</script>
<style  scoped>
.tab-container {
  height: 100%;
}
.zhengshu-list {
  width: 16rem;
  margin: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #ffffff !important;
}
.zhengshu-list > img:nth-child(2n + 1) {
  /* margin: 0 0.2rem; */
}
.zhengshu-list > img {
  margin-bottom: 0.4rem;
  margin-right: 0.2rem;
  height: auto;
  /* margin-bottom: 0.4rem;
  width: 5rem;
  height: 3.5rem; */
}
.img-bu {
  display: flex;
  flex-direction: column;
}
.img-bottom-list {
  width: 16rem;
  margin: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.img-margin-style {
  margin-bottom: 0.4rem;
  margin-right: 0.2rem;
}
</style>